import { withStyles } from '@material-ui/core/styles';
import { push } from 'connected-react-router';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setTitle_ac } from '../../actions/me.ac.js';
import { WidgetContainer } from '../Widgets/index.js';

/**
 * CoreFiveWidgetContainer - Embeds the Core Five verification widget
 *
 * This container can receive accountMember and interactionId from:
 * 1. Direct props (when used as a component)
 * 2. Route params (when accessed via URL like /core-five/:accountMember/:interactionId)
 *
 * Usage:
 * - As component: <CoreFiveWidgetContainer accountMember="A123456-1" interactionId="abc123" />
 * - Via route: /core-five/A123456-1/abc123
 */
class CoreFiveWidgetContainer extends React.Component {
  render() {
    const { match } = this.props;

    // Get props from either direct props or route params
    const accountMember =
      this.props.accountMember || (match && match.params && match.params.accountMember);
    const interactionId =
      this.props.interactionId || (match && match.params && match.params.interactionId);

    return (
      <WidgetContainer
        widgetName="core_five"
        widgetProps={{
          accountMember,
          interactionId,
        }}
        autoFullHeight={true}
        style={{
          width: '98%',
          marginTop: '10px',
          marginBottom: '10px',
          height: 'calc(100vh - 2px)',
        }}
      />
    );
  }
}

const mapStateToProps = (stateFromStore) => ({
  me: stateFromStore.me,
  lookups: stateFromStore.lookups,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setTitle_ac,
      changePage: (path) => push(path),
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles({})(CoreFiveWidgetContainer))
);
